export enum ScoringInputType {
    FirstHalfStart = 1,
    FirstHalfEnd = 2,
    ClipStart = 3,
    ClipEnd = 4,
    PlayerScore = 5,
    SecondHalfStart = 6,
    SecondHalfEnd = 7,
    YellowCard = 8,
    RedCard = 9,
    MidClip = 10,
    TeamScore = 11,
    YellowCardReturned = 12,
    Try = 13,
    RedCardReturned = 14,
    RefDecision = 15,
}